import { Fragment, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link, NavLink, Outlet,useOutletContext  } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { navLinkHeaderStylefunc, navfunc } from "../../../routes/navLinkStylefunc";
import { clientAccountBasePath, clientSubAccountBasePath, clientSubAccountView, clientSubAccountViewPath } from "../../../routes/routePaths";
import { getAccessTypes } from "../../../hooksAndFunctions/functions/getAccessTypes";
import { useGetSiteCoreCMSData } from "../../../reactQueries/commonRQHooks";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


const CommonButtonHeader = () => {
    const [adminClientAccountCmsData, setAdminClientAccountCmsData] = useState({ title: "", description: "", tabNavigationTitle: "", pageContent: {}, });
    const { isSuccess: isSuccessOnSiteCoreCMS, error: errorOnSiteCoreCMS, data: clinetAccountCmsFromApi, isError: isErrorOnSiteCoreCMS, isFetching: isFetchingOnSiteCoreCMS } = useGetSiteCoreCMSData({ pagename: "ClientAccounts" });

    const {
        clientPortalAdminType
    } = getAccessTypes()

    const {
        hasA2Access,
        hasA3Access
    } = clientPortalAdminType

    const fetchClientAccountCmsData = () => {
        if (clinetAccountCmsFromApi && clinetAccountCmsFromApi.Pages) {
            clinetAccountCmsFromApi.Pages.map((el) => {
                if (el.Key === "ClientAccounts") {
                    setAdminClientAccountCmsData(el);
                }
            });
        }
    }

    useEffect(() => {
        fetchClientAccountCmsData();
    }, [clinetAccountCmsFromApi]);

    return (
        <Fragment>
            <Box sx={{ width: '100%' }}>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={1}
                    justifyContent="center"
                    alignItems="center"
                    divider={<Divider orientation="vertical" flexItem />}
                >

                    <Button
                        variant="text"
                        size="large"
                        component={NavLink}
                        style={navLinkHeaderStylefunc}
                        to={clientAccountBasePath}
                        disabled={
                            //!!hasA2Access || hasA3Access
                            hasA3Access // removing disable for A2 access
                        }
                    >{adminClientAccountCmsData?.Components && adminClientAccountCmsData?.Components["ClientAccountsList"]?.Title}  </Button>

                    <Button
                        variant="text"
                        size="large"
                        component={NavLink}
                        style={navLinkHeaderStylefunc}
                        to={clientSubAccountBasePath}
                    >{adminClientAccountCmsData?.Components && adminClientAccountCmsData?.Components["ClientSubAccountGroupsList"]?.Title}  </Button>

                </Stack>
                <Divider sx={{ margin: '10px' }} />
            </Box>
            {/** aquires all child route element components */}
            <Outlet context={{refClientAccountCmsData:adminClientAccountCmsData}}/>
        </Fragment>
    );
}

export default CommonButtonHeader